export function plainObject<T = unknown, R = object & Partial<T>>(obj: T): R {
  return <R> JSON.parse(JSON.stringify(obj));
}
